import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { formatPrice, getBaseUrl, getFinanceWeekly, getLeaseBiWeeklyFromOptions } from '../../../utils';
import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import { useTranslation } from "react-i18next";

export const ColourCard = ({ Colour, Disabled, Selected, HandleSelectedColour, isExterior, Index, showFinancePrice, ...props }) => {

    const [colourData] = React.useState(Colour);
    const [selected] = React.useState(Selected);
    const financial = JSON.parse(sessionStorage.getItem(Constants.FinancialObj));
    const financeTermIndex = parseInt(sessionStorage.getItem(Constants.FinanceTermIndex));
    const leaseTermIndex = parseInt(sessionStorage.getItem(Constants.LeaseTermIndex));
    const financeTerm = parseInt(sessionStorage.getItem(Constants.FinanceTerm));
    const leaseTerm = parseInt(sessionStorage.getItem(Constants.LeaseTerm));
    const { t, i18n } = useTranslation(['colours', 'general']);

    function setSelectedColour(index) {
        HandleSelectedColour(index)
    }
    const imagePath = getBaseUrl() + process.env.REACT_APP_BASIC_CONTENT_PATH;
    const apiBasePath = process.env.API_URL_BASE_PATH;

    return (
        <button onClick={() =>{
			setSelectedColour(Index);

		}} className={`colour-card ${Selected?'colour-card-selected':''}`} disabled={Disabled}>
            {colourData ? <span className="colour-card__content">
                <img className="colour-card__img" alt={colourData.description} src={`${imagePath}${colourData.thumbnail}`   } />
                <span className={Selected ? "colour-card__selected-indicator selected" :  "colour-card__selected-indicator"}><i className="mz-svg mz-svg--white mz-svg-checkmark"></i></span>
                <span className="colour-card__info">
                    <span className="colour-card__title"><span className='text--red font-bold'>{Colour.new ? ReactHtmlParser(t('new')) : ''}</span>{ReactHtmlParser(Colour.description)}</span>
                    <span className="colour-card__price">{Colour.price!==0?`+ ${formatPrice(Colour.price)}`:''} <span>{Colour.price!==0? 
                        `(${showFinancePrice?
                            `${getFinanceWeekly(Colour.price, financial.calculatedFinance.financeValues[financeTermIndex].aprRate, financial.calculatedFinance.financeValues[financeTermIndex].term)}${t("general:week")}`:
                            `${getLeaseBiWeeklyFromOptions(Colour.price, financial.calculatedLease.leaseValues[leaseTermIndex].leaseRate, financial.calculatedLease.leaseValues[leaseTermIndex].term)}${t("general:bi_week")}`})`:''}</span></span>
                </span>
            </span> : null}
        </button>
    )

}


export default ColourCard;

ColourCard.propTypes = {
    HandleSelectedColour: PropTypes.func,
}

ColourCard.defaultProps = {
    HandleSelectedColour: () => { },
};